export default __webpack_public_path__ + "static/media/Walk (2).d60b9585.png";